import InfoIcon from "@assets/icons/info.svg";
import Play from "@assets/icons/play.svg";
import { useI18n } from "@core/i18n/i18n";
import { tutorialBannerManager } from "@core/service-container";
import { TutorialBannerType } from "@domain/tutorial-banner/tutorial-banner-manager";
import styled from "@emotion/styled";
import { WordingKey } from "@typings/i18n-typings";
import { Banner } from "@ui/components/common/banner";
import { TutorialDialog } from "@ui/components/tutorial/tutorial-dialog";
import { colors } from "@ui/style/colors";
import React, { useState } from "react";

interface TutorialBannerProps {
	bannerType: TutorialBannerType;
}

const BannerMessages = {
	[TutorialBannerType.INVITE_TO_HCT]: "tutorialBanner.hct",
	[TutorialBannerType.MONITOR_PATIENT_PROGRAM]: "tutorialBanner.monitorProgram",
} satisfies Record<TutorialBannerType, WordingKey>;

export const TutorialBanner: React.FC<TutorialBannerProps> = ({ bannerType }) => {
	const { format } = useI18n();
	const [dialogVisible, setDialogVisible] = useState(false);
	const tutorial = tutorialBannerManager.getTutorialLink(bannerType);

	if (!tutorial) return null;

	return (
		<>
			<Banner
				text={format(BannerMessages[bannerType])}
				icon={InfoIcon}
				uiStyle="success"
				rightComponent={
					<VideoCTA onClick={() => setDialogVisible(true)}>
						{format("tutorialBanner.cta")}
						<PlayIcon color={colors.primary} width={10} height={10} />
					</VideoCTA>
				}
				onDelete={() => tutorialBannerManager.closeBanner(bannerType)}
			/>
			<TutorialDialog
				visible={dialogVisible}
				tutorial={tutorial}
				tutorialType={bannerType}
				onHide={() => setDialogVisible(false)}
			/>
		</>
	);
};

const VideoCTA = styled.div`
	color: ${colors.primary};
	font-size: 16px;
	font-weight: 700;
	cursor: pointer;
`;

const PlayIcon = styled(Play)`
	margin-left: 10px;
`;
